// components/PaymentItemView.jsx
import styled from 'styled-components';

const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 8px;
  gap: 8px;
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 50px;
  height: 50px;
  flex-shrink: 0;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
  }
`;

const QuantityBadge = styled.div`
  position: absolute;
  top: -6px;
  right: -6px;
  background-color: ${({ theme }) => theme.colors.menuText};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.65rem;
  font-weight: bold;
`;

const InfoWrapper = styled.div`
  flex: 1;
  margin-left: 8px;
  font-size: 0.75rem;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.primaryText};
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
`;

const Price = styled.div`
  font-size: 0.8rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primaryText};
  white-space: nowrap;
  flex-shrink: 0;
`;

const PaymentItemView = ({ item }) => {
  return (
    <ItemContainer>
      <ImageWrapper>
        <img
          src={`${process.env.REACT_APP_FILE_UPLOAD_URL}${item.filepath1}`}
          alt={item.idStyle}
        />
        <QuantityBadge>{item.totQty}</QuantityBadge>
      </ImageWrapper>
      <InfoWrapper>{item.webTitle}</InfoWrapper>
      <Price>${item.price.toFixed(2)}</Price>
    </ItemContainer>
  );
};

export default PaymentItemView;
